export const shouldLoad = () => document.querySelector('[data-controller="employee-card"]') !== undefined;